<template>
  <div
    v-if="x.totalResults"
    class="x-flex x-w-full x-flex-row x-items-center x-justify-between x-gap-16"
  >
    <div class="x-flex x-flex-auto x-items-center x-justify-end">
      <i18n-t
        class="x-text1 x-text1-lg x-flex-auto x-font-light x-text-neutral-90"
        keypath="totalResults.message"
        tag="span"
        scope="global"
        :plural="x.totalResults"
      >
        <template #totalResults>
          {{ x.totalResults }}
        </template>
        <template #query>
          <span class="x-title3">
            {{ x.spellcheckedQuery || query }}
          </span>
        </template>
      </i18n-t>

      <SortSelector />
    </div>
  </div>
</template>

<script setup lang="ts">
import { use$x, useGetter } from '@empathyco/x-components'
import SortSelector from '../search/sort-selector.vue'

const x = use$x()
const { query } = useGetter('search')
</script>
